import { GraphQLClient } from "graphql-request";
import { Auth } from 'aws-amplify';

const REACT_APP_AWS_GRAPHQL_URL = process.env.REACT_APP_AWS_GRAPHQL_URL
const REACT_APP_AWS_GRAPHQL_API_KEY = process.env.REACT_APP_AWS_GRAPHQL_API_KEY

export const graphQLClient = () => {
  return new Promise((resolve, reject) => {
    Auth.currentSession()
      .then(session => {
        const accessToken = session.getAccessToken().getJwtToken();
        
        const headers = {
          Accept: "modeler/json",
          // 'x-api-key': REACT_APP_AWS_GRAPHQL_API_KEY
          "Authorization": accessToken
        };

        const client = new GraphQLClient(REACT_APP_AWS_GRAPHQL_URL, { headers });
        resolve(client);
      })
      .catch(error => {
        console.error("Error getting session:", error);
        reject(error);
      });
  });
};

export const createContext = (user_id, requestType, resourceType, resourceId = null, entityType=null) => {
  return {
    requesterId: user_id,
    requestType: requestType,
    resourceType: resourceType,
    entityType: entityType,
    resourceId: resourceId,
  };
};
export const executeGraphQLRequest = (dispatch, getState, actionCreators, query, variables, context) => {
  let { begin, success, failure } = actionCreators;

  if (begin) {
    dispatch(begin());
  }

  return graphQLClient()
    .then(client => client.request(query, { ...variables }, context))
    .then(res => {
      if (success) {
        dispatch(success(res));
      }
    })
    .catch(err => {
      if (failure) {
        dispatch(failure(err.message));
      }
    });
};
